"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSMainComponent = void 0;
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../shared/services/expresspay.services");
const shared_1 = require("../../../mma/shared");
const router_1 = require("@angular/router");
class CSMainComponent {
    constructor(expressPayService, helperService, router, zone, applicationRef) {
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.router = router;
        this.zone = zone;
        this.applicationRef = applicationRef;
        this.goToMyAccount = function () {
            // this.router.navigate('/my_account/personal/');
            this.helperService.onNavigate('/my_account/personal/');
        };
        this.expressPayService.signedInStatusEmitted$.subscribe((signedInStatus) => {
            this.isSignedIn = signedInStatus;
        });
        this.router.events.subscribe((e) => {
            this.zone.run(() => setTimeout(() => {
                this.applicationRef.tick();
            }, 0));
        });
    }
}
exports.CSMainComponent = CSMainComponent;
//# sourceMappingURL=main.component.js.map